import { rfqMyQuotesPaginationStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesPagination";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";

rfqMyQuotesPaginationStyles.pagination = getMgbwPaginationOverrides();
